import React from 'react';
import {IWorkspaceItem} from "../../models/Workspace";
import {TextField} from "@fluentui/react";
import {useGetWorkspaceQuery} from "../../store/Api";
import {usePutWorkspaceItemDetailsMutation} from "../../store/endpoints/WorkspaceItemsEndpoints";

interface IMarkupEntryProps {
    item: IWorkspaceItem;
    isExample?: boolean;
}

const MarkupEntry: React.FC<IMarkupEntryProps> = (props) => {
    const workspace = useGetWorkspaceQuery(props.item.workspace, {
        skip: (!props.item.workspace ||  props.item.workspace.trim().length === 0 || props.item.workspace === "example workspace")
    });
    const defaultMarkup = workspace?.data?.defaultMarkup;
    const [detailsChange] = usePutWorkspaceItemDetailsMutation();
    const [val, setVal] = React.useState<string | undefined>(undefined);

    React.useEffect(() => {
        if (props.item.details?.markup !== 0) {
            setVal(props.item.details?.markup?.toString());
        }
    }, [props.item.details?.markup])

    const update = (v: string | undefined) => {
        if(props.isExample) return;
        detailsChange({
            workspace: props.item.workspace,
            product: props.item.id,
            details: {
                ...props.item.details,
                markup: v ? parseFloat(v) : undefined,
            }
        })

    }

    return (
        <TextField
            placeholder={defaultMarkup?.toString() ?? 'Not Set'}
            suffix={'%'}
            value={val}
            type={'number'}
            className={'italic-placeholder'}
            onChange={(e, v) => {
                setVal(v);
            }}
            onBlur={(e) => update(e.target.value)}
            onKeyDown={(e) => {
                if (e.key === 'Enter') {
                    update(e.currentTarget.value);
                }
            }}
            />
    )
}

export default MarkupEntry;